// extracted by mini-css-extract-plugin
export default {"banner":"banner_banner__8Ob5O","art":"banner_art__3TIXD","overlay":"banner_overlay__Cdv-Q"};